import RightTimeApi from "@/API"; // Ensure you import RightTimeApi if it's used
import { MdCheckBoxOutlineBlank, MdCheckBox, MdCameraswitch } from "react-icons/md";
import { toast } from "react-toastify";
import Helpers from "../../Helpers";

export default function SiteAccess(props) {
  if (!props?.activeTestType?.companyTestType || !props.lookups || !props.lookups.sites) return null;

  async function toggleSiteTestAsync(e) {
    let siteId = parseInt(e.currentTarget.getAttribute("site-id"));
    let updateData = {
      siteId: siteId,
      testTypeId: props.activeTestType.companyTestType.testTypeId,
      companyTestTypeId: props.activeTestType.companyTestType.id,
    };
    props.updateSpinner(true);
    const resp = await RightTimeApi.putAsync("/SiteTestActiveToggle", updateData);
    props.updateSpinner(false);

    if (resp && resp.ok) {
      let site = props.lookups.sites.find((s) => s.id === siteId);
      if (site) {
        if (resp.jsonData.active)
          toast.success(
            "Test '" + resp.jsonData.testName + "' activated for " + site.name
          );
        else
          toast.success(
            "Test '" +
            resp.jsonData.testName +
            "' de-activated for " +
            site.name
          );
      } else {
        if (resp.jsonData.active)
          toast.success("Test '" + resp.jsonData.testName + "' activated");
        else
          toast.success("Test '" + resp.jsonData.testName + "' de-activated");
      }
      props.updateData();
    }
  }

  async function toggleAllSiteTestsAsync() {
    const sites = props.lookups?.sites || [];
    const allSiteIds = sites.map((site) => site.id);
    if (allSiteIds.length === 0) return;

    const activeSiteSet = new Set(props.activeTestType?.sites || []);
    const checkedCount = allSiteIds.filter((siteId) => activeSiteSet.has(siteId)).length;
    const uncheckedCount = allSiteIds.length - checkedCount;
    const shouldUncheckAll = checkedCount > uncheckedCount;

    const siteIdsToToggle = allSiteIds.filter((siteId) =>
      shouldUncheckAll ? activeSiteSet.has(siteId) : !activeSiteSet.has(siteId)
    );

    if (siteIdsToToggle.length === 0) return;

    props.updateSpinner(true);
    let successfulToggles = 0;

    for (const siteId of siteIdsToToggle) {
      const updateData = {
        siteId,
        testTypeId: props.activeTestType.companyTestType.testTypeId,
        companyTestTypeId: props.activeTestType.companyTestType.id,
      };

      const resp = await RightTimeApi.putAsync("/SiteTestActiveToggle", updateData);
      if (resp?.ok) {
        successfulToggles += 1;
      }
    }

    props.updateSpinner(false);

    if (successfulToggles === siteIdsToToggle.length) {
      toast.success(
        shouldUncheckAll
          ? `Removed access for all ${Helpers.pluralize(props.siteEntityName, allSiteIds.length).toLowerCase()}.`
          : `Granted access for all ${Helpers.pluralize(props.siteEntityName, allSiteIds.length).toLowerCase()}.`
      );
      props.updateData();
      return;
    }

    if (successfulToggles > 0) {
      toast.warning("Some site access updates failed.");
      props.updateData();
    } else {
      toast.error("Failed to update site access.");
    }
  }

  // console.log("SiteAccess props:", props);
  return(
  <div className="tableWrapper factTable nohover inline-block siteAccessTable">
    <table className="formTable">
      {/* {(()=>{debugger})()} */}
      <caption>
        <span className="title">{props.activeTestType.companyTestType.name} /{" "}
        {Helpers.pluralize(props.siteEntityName)}</span>
      </caption>
      <thead>
        <tr>
          <th>{props.siteEntityName}</th>
          <th className="toggleColumnHeader" 
              onClick={toggleAllSiteTestsAsync} style={{ cursor: "pointer" }} 
              data-help-id="toggleActive">
            <span className="toggleHeaderLabel">Access</span>
            <span className="toggleHeaderIcon" aria-hidden="true">
              <MdCameraswitch />
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        {props.lookups && props.lookups.sites
          ? props.lookups.sites.map((site, i) => {
            return (
              <tr key={"site" + i}>
                <th>{site.name}</th>
                <td
                  className="actions center"
                  site-id={site.id}
                  onClick={toggleSiteTestAsync}
                >
                  {/* {(()=>{debugger})()} */}
                  {props.activeTestType.sites.includes(site.id) ? (
                    <MdCheckBox className="checkbox checked actionIcon" />
                  ) : (
                    <MdCheckBoxOutlineBlank className="checkbox unchecked actionIcon" />
                  )}
                </td>
              </tr>
            );
          })
          : null}
      </tbody>
    </table>
  </div>);
}

